import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3651478b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "amount-col is-flex-direction-column left" }
const _hoisted_2 = { class: "amount" }
const _hoisted_3 = { class: "amount" }
const _hoisted_4 = { class: "currency" }
const _hoisted_5 = {
  key: 0,
  class: "custom-card-type"
}
const _hoisted_6 = {
  key: 1,
  class: "custom-card-related"
}
const _hoisted_7 = {
  key: 2,
  class: "has-text-grey-light transaction-desc"
}
const _hoisted_8 = {
  key: 0,
  class: "center"
}
const _hoisted_9 = { class: "status-label" }
const _hoisted_10 = { class: "status-indicator" }
const _hoisted_11 = {
  key: 1,
  class: "custom-card-related related small"
}
const _hoisted_12 = {
  key: 2,
  class: "is-pulled-right right"
}
const _hoisted_13 = {
  key: 0,
  class: "custom-card-related has-text-right"
}
const _hoisted_14 = { class: "status card-paiement-defaut-carte has-text-right mt-1" }
const _hoisted_15 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WorkflowIndicator = _resolveComponent("WorkflowIndicator")!
  const _component_fa_icon = _resolveComponent("fa-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["p-3 shadow-bottom tx-item", {
      topup: _ctx.transaction.isTopUp,
      reconversion: _ctx.transaction.isReconversion,
      cm: _ctx.transaction.tags && _ctx.transaction.tags.includes('barter'),
      'mode-small': _ctx.mode === 'small',
      'cursor-pointer': _ctx.mode !== 'small',
    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", {
        class: _normalizeClass([
          _ctx.transaction.amount.toString().charAt(0) == '-'
            ? 'custom-card-related has-text-danger'
            : 'custom-card-related has-text-success',
        ])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.numericFormat(parseFloat(_ctx.transaction.amount))), 1)
        ]),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.transaction.currency), 1)
      ], 2),
      (_ctx.mode !== 'small')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_ctx.transaction.isTopUp || _ctx.transaction.isReconversion)
              ? (_openBlock(), _createElementBlock("h5", _hoisted_5, _toDisplayString(_ctx.transaction.isTopUp ? _ctx.$gettext("Top-up") : _ctx.$gettext("Reconversion")), 1))
              : (_openBlock(), _createElementBlock("h4", _hoisted_6, _toDisplayString(_ctx.transaction.related), 1)),
            (!_ctx.transaction.isTopUp && !_ctx.transaction.isReconversion)
              ? (_openBlock(), _createElementBlock("h5", _hoisted_7, _toDisplayString(_ctx.transaction.description), 1))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    (
        _ctx.mode !== 'small' &&
        _ctx.$config.disableReconversionStatusDisplay !== true &&
        _ctx.transaction.isReconversion
      )
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.reconversionStatus), 1),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_WorkflowIndicator, {
              format: "small",
              stages: _ctx.reconversionStatuses,
              current: _ctx.reconversionStatus
            }, null, 8, ["stages", "current"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.mode === 'small')
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.transaction.related), 1))
      : _createCommentVNode("", true),
    (_ctx.transaction?.pending !== null || _ctx.transaction?.date !== null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          (_ctx.mode !== 'small')
            ? (_openBlock(), _createElementBlock("h5", _hoisted_13, _toDisplayString(_ctx.dateFormat(_ctx.transaction.date)), 1))
            : _createCommentVNode("", true),
          _createElementVNode("h5", _hoisted_14, [
            (_ctx.transaction.date)
              ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.relativeDateFormat(_ctx.transaction.date)), 1))
              : _createCommentVNode("", true),
            _createVNode(_component_fa_icon, {
              class: _normalizeClass([{
            hide:
              _ctx.transaction?.pending === true || _ctx.transaction?.pending === null,
          }, "fa-thin ml-1"]),
              icon: "check"
            }, null, 8, ["class"])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}